/*
 * Funikido Sep30 - GA4-shaped ecommerce events for Google Tag Manager.
 * Page-level data is seeded by snippets/funikido-gtm-datalayer.liquid into
 * window.FKGTM before gtm.js loads. This file turns it into dataLayer events
 * and watches the theme's cart requests for add / remove.
 *
 * Events pushed: view_item, view_item_list, select_item, view_cart,
 *                add_to_cart, remove_from_cart, buy_now, scroll_up.
 * begin_checkout / add_payment_info / purchase come from the checkout
 * custom pixel, NOT from here, so they are never counted twice.
 */
(function () {
  'use strict';

  var CFG = window.FKGTM || {};
  var CURRENCY = CFG.currency || 'INR';
  window.dataLayer = window.dataLayer || [];

  function push(name, ecommerce) {
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: name, ecommerce: ecommerce });
    } catch (e) {}
  }

  function money(cents) {
    var n = Number(cents);
    return isNaN(n) ? 0 : Math.round(n) / 100;
  }

  function lineToItem(line, index) {
    var item = {
      item_id: line.sku || String(line.variant_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      price: money(line.final_price != null ? line.final_price : line.price),
      quantity: line.quantity || 1
    };
    if (line.vendor) item.item_brand = line.vendor;
    if (line.product_type) item.item_category = line.product_type;
    if (line.variant_title) item.item_variant = line.variant_title;
    if (typeof index === 'number') item.index = index;
    return item;
  }

  function itemsValue(items) {
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      total += (items[i].price || 0) * (items[i].quantity || 1);
    }
    return Math.round(total * 100) / 100;
  }

  /* ---------- view_item ---------- */
  if (CFG.product) {
    push('view_item', {
      currency: CURRENCY,
      value: CFG.product.price,
      items: [CFG.product]
    });
  }

  /* ---------- view_item_list ---------- */
  if (CFG.list && CFG.list.items && CFG.list.items.length) {
    push('view_item_list', {
      item_list_id: CFG.list.item_list_id,
      item_list_name: CFG.list.item_list_name,
      items: CFG.list.items
    });
  }

  /* ---------- view_cart ---------- */
  if (CFG.cart && CFG.cart.items && CFG.cart.items.length &&
      /\/cart\/?$/.test(window.location.pathname)) {
    push('view_cart', {
      currency: CURRENCY,
      value: CFG.cart.value,
      items: CFG.cart.items
    });
  }

  /* ---------- select_item ---------- */
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var link = target.closest('a[href*="/products/"]');
    if (!link) return;

    var handle = (link.getAttribute('href') || '').split('/products/')[1] || '';
    handle = handle.split('?')[0].split('#')[0].replace(/\/$/, '');
    if (!handle) return;

    var name = '';
    var card = link.closest('.card-wrapper, .grid__item, li');
    if (card) {
      var title = card.querySelector('.card__title, h3, h2');
      if (title) name = (title.textContent || '').trim();
    }

    var payload = { items: [{ item_id: handle, item_name: name || handle, quantity: 1 }] };
    if (CFG.list) {
      payload.item_list_id = CFG.list.item_list_id;
      payload.item_list_name = CFG.list.item_list_name;
    }
    push('select_item', payload);
  }, true);

  /* ---------- cart snapshot, used to diff add vs remove ---------- */
  var lastCart = null;

  function snapshot(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      map[items[i].key || items[i].variant_id] = items[i].quantity;
    }
    return { map: map, items: items };
  }

  function refreshCart() {
    try {
      return window.__fkOrigFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { lastCart = snapshot(c); })
        .catch(function () {});
    } catch (e) {}
  }

  function onAdd(data) {
    if (!data) return;
    var lines = (data.items && Object.prototype.toString.call(data.items) === '[object Array]')
      ? data.items
      : [data];
    var items = [];
    for (var i = 0; i < lines.length; i++) {
      var item = lineToItem(lines[i]);
      if (item.item_name) items.push(item);
    }
    if (!items.length) return;
    push('add_to_cart', { currency: CURRENCY, value: itemsValue(items), items: items });
    refreshCart();
  }

  function onChange(cart) {
    if (!cart || !cart.items) return;
    if (!lastCart) { lastCart = snapshot(cart); return; }

    var before = lastCart.map;
    var beforeItems = lastCart.items;
    var after = snapshot(cart);
    var removed = [];
    var added = [];
    var key, i, src, item;

    for (key in before) {
      if (!Object.prototype.hasOwnProperty.call(before, key)) continue;
      var wasQty = before[key];
      var nowQty = after.map[key] || 0;
      if (nowQty < wasQty) {
        src = null;
        for (i = 0; i < beforeItems.length; i++) {
          if (String(beforeItems[i].key || beforeItems[i].variant_id) === String(key)) {
            src = beforeItems[i];
            break;
          }
        }
        if (src) {
          item = lineToItem(src);
          item.quantity = wasQty - nowQty;
          removed.push(item);
        }
      }
    }

    for (key in after.map) {
      if (!Object.prototype.hasOwnProperty.call(after.map, key)) continue;
      var nowQ = after.map[key];
      var wasQ = before[key] || 0;
      if (nowQ > wasQ) {
        src = null;
        for (i = 0; i < after.items.length; i++) {
          if (String(after.items[i].key || after.items[i].variant_id) === String(key)) {
            src = after.items[i];
            break;
          }
        }
        if (src) {
          item = lineToItem(src);
          item.quantity = nowQ - wasQ;
          added.push(item);
        }
      }
    }

    if (removed.length) {
      push('remove_from_cart', { currency: CURRENCY, value: itemsValue(removed), items: removed });
    }
    if (added.length) {
      push('add_to_cart', { currency: CURRENCY, value: itemsValue(added), items: added });
    }
    lastCart = after;
  }

  function route(url, data) {
    if (/\/cart\/add/.test(url)) onAdd(data);
    else onChange(data);
  }

  /* ---------- watch fetch ---------- */
  window.__fkOrigFetch = window.fetch ? window.fetch.bind(window) : null;
  if (window.__fkOrigFetch) {
    window.fetch = function () {
      var url = '';
      try {
        url = typeof arguments[0] === 'string'
          ? arguments[0]
          : (arguments[0] && arguments[0].url) || '';
      } catch (e) {}

      var promise = window.__fkOrigFetch.apply(null, arguments);

      if (url && /\/cart\/(add|change|update)/.test(url)) {
        try {
          promise.then(function (res) {
            try {
              res.clone().json().then(function (data) { route(url, data); }).catch(function () {});
            } catch (e) {}
          }).catch(function () {});
        } catch (e) {}
      }
      return promise;
    };
  }

  /* ---------- watch XMLHttpRequest ---------- */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__fkUrl = url; } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var url = xhr.__fkUrl || '';
    if (url && /\/cart\/(add|change|update)/.test(url)) {
      xhr.addEventListener('load', function () {
        try { route(url, JSON.parse(xhr.responseText)); } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };


  /* ---------- buy_now: the Go to Checkout / Buy it now click ---------- */
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var el = target.closest('[name="checkout"], .shopify-payment-button__button, a[href*="/checkout"]');
    if (!el) return;
    var items = [];
    if (lastCart && lastCart.items) {
      for (var i = 0; i < lastCart.items.length; i++) {
        items.push(lineToItem(lastCart.items[i], i));
      }
    }
    push('buy_now', { currency: CURRENCY, value: itemsValue(items), items: items });
  }, true);

  /* ---------- scroll_up ----------
   * GTM's own Scroll Depth trigger only fires going DOWN, so upward scroll
   * has to come from here. Fires at most once per page view: the reader must
   * have gone at least 25% down, then scrolled back up by half a screen. */
  (function () {
    var maxDepth = 0;
    var lastY = window.pageYOffset || 0;
    var upAccum = 0;
    var fired = false;

    function depth() {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return 0;
      var pct = ((window.pageYOffset || 0) / scrollable) * 100;
      return Math.max(0, Math.min(100, Math.round(pct)));
    }

    function onScroll() {
      var y = window.pageYOffset || 0;
      var d = depth();
      if (d > maxDepth) maxDepth = d;

      var delta = lastY - y;
      if (delta > 0) upAccum += delta;
      else if (delta < 0) upAccum = 0;
      lastY = y;

      if (!fired && maxDepth >= 25 && upAccum >= window.innerHeight * 0.5) {
        fired = true;
        try {
          window.dataLayer.push({
            event: 'scroll_up',
            scroll_depth: d,
            max_scroll_depth: maxDepth
          });
        } catch (e) {}
      }
    }

    try {
      window.addEventListener('scroll', onScroll, { passive: true });
    } catch (e) {
      window.addEventListener('scroll', onScroll);
    }
  })();

  refreshCart();
})();
